import { atomWithStorage } from 'jotai/utils';

import { getUserLanguage, getUserLocale } from 'common/utils/localeUtils';

export const userLanguageAtom = atomWithStorage('language', getUserLanguage());

export const userLocaleAtom = atomWithStorage('locale', getUserLocale());
